import React, { memo } from "react"
import styled from "styled-components"
import BannerCardHeader from "./BannerCardHeader"
import BannerCardFooter from "./BannerCardFooter"
import BannerCardContent from "./BannerCardContent"
import clsx from "clsx"

const BannerCardContainer = styled.div<{ bgColor: string; bgColorSecondary: string }>`
  max-width: 226px;
  width: 100%;
  height: 293px;
  border-radius: 12px;
  border: 1px solid ${(props) => props.theme.palette.mediumGray};
  background-color: ${(props) => props.bgColor};
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;

  &.gradient {
    background: linear-gradient(135deg, ${(props) => props.bgColor} 0%, ${(props) => props.bgColorSecondary} 100%);
  }
`

interface BannerCardProps {
  backgroundColor: string
  backgroundColorSecondary: string
  bannerImageFile: File | undefined
  bannerImageUrl: string
  logoFile: File | undefined
  logoUrl: string
  isGradient: boolean
  handleBannerFileChange: (files: File[]) => void
}

const BannerCard: React.FC<BannerCardProps> = (props: BannerCardProps) => {
  const {
    backgroundColor,
    backgroundColorSecondary,
    bannerImageFile,
    bannerImageUrl,
    logoFile,
    handleBannerFileChange,
    logoUrl,
    isGradient
  } = props

  return (
    <BannerCardContainer
      bgColor={backgroundColor}
      bgColorSecondary={backgroundColorSecondary}
      className={clsx({ gradient: isGradient })}
    >
      <BannerCardHeader logoFile={logoFile} logoUrl={logoUrl} />
      <BannerCardContent
        bannerImageFile={bannerImageFile}
        bannerImageUrl={bannerImageUrl}
        handleBannerFileChange={handleBannerFileChange}
      />
      <BannerCardFooter />
    </BannerCardContainer>
  )
}

export default memo(BannerCard)
